export default {
    logout() {
        localStorage.clear();
        window.location = '/login';
    }
}
